import { buildBackgroundLayerClassname } from './classNameUtils';
export default function combineBreakpointStyles(breakpointMediaQueries, stylesByBreakpointName, nodeId, backgroundLayerStylesByBreakpointName, nodeSelector) {
  return breakpointMediaQueries.flatMap(([breakpointName, mediaQuery]) => {
    const backgroundLayerClassname = buildBackgroundLayerClassname(nodeId, breakpointName);
    const rules = [];
    if (breakpointName === 'default') {
      const stylesForBreakpoint = stylesByBreakpointName[breakpointName];
      if (stylesForBreakpoint && stylesForBreakpoint.length > 0) {
        rules.push([nodeSelector, stylesForBreakpoint.join(' '), '']);
      }
      const backgroundLayerStyles = backgroundLayerStylesByBreakpointName[breakpointName];
      if (backgroundLayerStyles && backgroundLayerStyles.length > 0) {
        rules.push([`${nodeSelector} > .dnd-grid-background > :not(.${backgroundLayerClassname})`, 'display: none;', mediaQuery]);
        rules.push([`${nodeSelector} > .dnd-grid-background > .${backgroundLayerClassname}`, 'height: 100%; width: 100%;', mediaQuery]);
        backgroundLayerStyles.forEach(([layerSelector, ruleString]) => {
          rules.push([layerSelector, ruleString, mediaQuery]);
        });
      }
      return rules;
    }
    const stylesForBreakpoint = stylesByBreakpointName[breakpointName];
    if (stylesForBreakpoint && stylesForBreakpoint.length > 0) {
      rules.push([nodeSelector, stylesForBreakpoint.join(' '), mediaQuery]);
    }
    const backgroundLayerStyles = backgroundLayerStylesByBreakpointName[breakpointName];
    rules.push([`${nodeSelector} > .dnd-grid-background > .${backgroundLayerClassname}`, 'display: none;', '']);
    if (backgroundLayerStyles && backgroundLayerStyles.length > 0) {
      rules.push([`${nodeSelector} > .dnd-grid-background > :not(.${backgroundLayerClassname})`, 'display: none;', mediaQuery]);
      rules.push([`${nodeSelector} > .dnd-grid-background > .${backgroundLayerClassname}`, 'height: 100%; width: 100%; display: block;', mediaQuery]);
      backgroundLayerStyles.forEach(([layerSelector, ruleString]) => {
        rules.push([layerSelector, ruleString, mediaQuery]);
      });
    }
    return rules;
  });
}